import { render, staticRenderFns } from "./ModalControleTokenServico.vue?vue&type=template&id=9358458a&scoped=true"
import script from "./ModalControleTokenServico.vue?vue&type=script&lang=js"
export * from "./ModalControleTokenServico.vue?vue&type=script&lang=js"
import style0 from "./ModalControleTokenServico.vue?vue&type=style&index=0&id=9358458a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9358458a",
  null
  
)

export default component.exports